
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecocredits-appreciation-week",
      function () {
        return require("private-next-pages/ecocredits-appreciation-week/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecocredits-appreciation-week"])
      });
    }
  